const DAY_MS = 86400000;

const toDate = (value) => {
	const d = new Date(value);
	return new Date(d.getFullYear(), d.getMonth(), d.getDate());
};

const daysUntil = (expire, today) =>
	Math.ceil((toDate(expire) - toDate(today)) / DAY_MS);

export function cardDisplayType(card, todayStr) {
	if (card.type !== 'red') {
		return card.type;
	}

	const duration = Number(card.duration) || 0;
	if (duration <= 0) {
		return 'red';
	}

	const half = Math.ceil(duration / 2);
	const expire = new Date(toDate(card.date));
	expire.setDate(expire.getDate() + duration);

	const remaining = daysUntil(expire, todayStr);

	return remaining <= half ? 'yellow' : 'red';
}

export function cardDegradesToYellow(card) {
	if (card.type !== 'red') {
		return false;
	}
	const duration = Number(card.duration) || 0;
	return duration > 0;
}

export function cardDegradationDate(card) {
	if (!cardDegradesToYellow(card)) {
		return null;
	}
	const duration = Number(card.duration) || 0;
	const half = Math.ceil(duration / 2);
	const date = toDate(card.date);
	date.setDate(date.getDate() + half);
	const y = date.getFullYear();
	const m = String(date.getMonth() + 1).padStart(2, '0');
	const d = String(date.getDate()).padStart(2, '0');
	return `${y}-${m}-${d}`;
}

export function cardRedRemaining(card) {
	return Math.max(
		0,
		(Number(card.remaining) || 0) - Math.ceil((Number(card.duration) || 0) / 2)
	);
}
